<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md12>
        <v-card>
          <v-toolbar dense flat light color="grey lighten-5">
            <v-toolbar-title>Numaralara Whatsapp Mesajı Gönder</v-toolbar-title>
          </v-toolbar>
          <div style="padding: 15px;" v-if="!whatsappStatus">
            <v-alert type="warning">Whatsapp numaranız aktif değil. <a href="/whatsapp/settings" style="color:#fff">Buraya</a> tıklayarak veya Ayarlar sayfasına giderek numaranızı aktive edebilirsiniz.</v-alert>
          </div>
          <v-layout wrap>
            <v-flex>
              <v-card-text>
                <root-list
                  :items="data.groups"
                  search-label="Grupları filtrelemek için arama yapınız."
                  @rip:change="loadGroups"
                  @rip:child="childChange"
                  search
                  smart
                >
                </root-list>
              </v-card-text>
            </v-flex>
            <v-divider vertical> </v-divider>

            <v-flex md4 fill-height id="scroll-target">
              <contact-list
                v-model="groupContacts"
                v-scroll:#scroll-target="onScroll"
                class="tt"
                :header="groupContactName"
                :filter="tree"
                :pagination="pagination"
                @con:select-all="selectAll"
                @con:change="addSelectedContact"
                @con:filter-change="lastTree"
                @con:search="contactSearch"
                @con:length="contactsPageFinished"
                item-value="name"
                no-value-text="Seçili bir grup veya grubun rehberi yok."
              >
              </contact-list>
              <v-pagination
                circle
                v-model="pagination.current"
                :page="pagination.current"
                :length="pagination.total"
                :total-visible="6"
                @input="
                  onSearching
                    ? contactsSearchPagination(pagination.current)
                    : contactsPagination(pagination.current)
                "
              >
              </v-pagination>
            </v-flex>

            <v-divider vertical> </v-divider>

            <v-flex xs12 md4 class="tt">
              <v-card-text>
                <div
                  v-if="tree.length === 0"
                  class="title font-weight-light grey--text pa-4 text-center"
                >
                  Seçili rehber kaydı yok.
                </div>

                <v-scroll-x-transition group hide-on-leave>
                  <v-chip
                    v-for="(selection, i) in tree"
                    :key="i"
                    color="grey"
                    close
                    @click:close="removeSelected(selection)"
                    dark
                    medium
                    class="ma-1"
                  >
                    <v-icon left small color="light-blue lighten-4"
                      >done_all</v-icon
                    >
                    {{ selection.name }} {{ selection.surname }}
                  </v-chip>
                </v-scroll-x-transition>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center>
            <v-flex xs10 d-flex>
              <v-btn block color="primary" @click.stop="createMessage" :disabled="!whatsappStatus ? true : false">
                Mesajı Oluştur <v-icon right dark>mdi-send</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <whatsapp-prepare
      v-show="whatsappPreparing"
      :confirmation="confirmation"
      :valid="whatsappPreparing"
      :data="prepareData"
      @on:close="whatsappPreparing = !whatsappPreparing"
      @on:send="whatsappSending"
      @on:preview="whatsappPreview"
      @update:confirmation="(valid) => (confirmation.valid = valid)"
    >
    </whatsapp-prepare>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import RootList from '../../../Components/SelectiveList/RootList.vue';
import ContactList from '../../../Components/SelectiveList/ContactList.vue';
import WhatsappPrepare from '../../../Components/SelectiveMessage/WhatsappPrepare.vue';

export default {
  name: 'Selective',
  components: {
    WhatsappPrepare,
    ContactList,
    RootList,
  },
  data: () => ({
    whatsappStatus: true,
    topReach: 0,
    scroll: '',
    whatsappPreparing: false,
    groupContacts: [],
    groupContactName: '',
    pagination: {
      current: 0,
      total: 1,
    },
    data: {},
    lastTree: {},
    prepareData: {
      senders: [],
    },
    tree: [],
    currentParameter: {},
    confirmation: {
      valid: false,
      context: {
        examples: [],
      },
    },
    onSearching: false,
    keyword: '',
  }),
  created() {
    Vue.axios({
      url: `${this.$store.getters.apiEndpoint}whatsapp/check-device-active`,
      data: {},
      method: 'POST',
      statusCode: 500,
      responseType: 'JSON',
    }).then((res) => {
      this.whatsappStatus = res.data.data.device || res.data.data.other_devices && res.data.data.account_status;
    });
  },

  methods: {
    ...mapActions({ send: 'sendBackend', sendAsync: 'asyncSender' }),
    selectAll() {
      this.groupContacts = [];
      this.loadGroupContacts(this.currentParameter);
    },
    loadGroups() {
      this.send({ route: 'whatsapp/selective' }).then((res) => {
        this.data = res.data.data;
      });
    },
    setInitial() {
      this.groupContacts = [];
      this.pagination = {
        current: 0,
        total: 1,
      };
    },
    childChange(val) {
      this.setInitial();
      this.onSearching = false;
      this.loadGroupContacts(val);
    },
    loadGroupContacts(val) {
      if (this.pagination.total >= this.pagination.current) {
        this.currentParameter = val;
        this.send({
          route: `details/group?page=${this.pagination.current}`,
          data: { id: [val.id] },
        }).then(async (res) => {
          this.groupContacts = [
            ...this.groupContacts,
            ...res.data.data.contacts.data,
          ];
          this.groupContactName = `${val.name} (${res.data.data.contacts.total})`;

          this.pagination.current = await res.data.data.contacts.current_page;
          this.pagination.total = res.data.data.contacts.last_page;
          this.pagination.group_id = val.id;
          this.pagination.group_name = val.name;

          /*
             Burası aktif olursa kaydı olmayan bir grup geldiğinde ard arda 100-200 istek atıyor
             if (this.groupContacts.length <= 10) {
              this.loadGroupContacts(val);
            }
            */
        });
      }
    },
    addSelectedContact(val) {
      if (this.tree.filter(t => t.id === val.id).length === 0) {
        this.tree.push(val);
      } else if (this.tree.length === 0) {
        this.tree.push(val);
      }
    },
    removeSelected(val) {
      this.tree = this.tree.filter(con => con !== val);
      this.$trigger('con:filter-change', val);
    },
    contactsPagination(val) {
      const route = `details/group?page=${val}`;
      const data = { id: [this.pagination.group_id] };
      this.send({ route, data }).then((res) => {
        this.groupContacts = res.data.data.contacts.data;
        this.groupContactName = `${res.data.data.name} (${res.data.data.contacts.total})`;

        this.pagination.current = res.data.data.contacts.current_page;
        this.pagination.total = res.data.data.contacts.last_page;
        this.pagination.group_id = res.data.data.id;
      });
    },
    contactsSearchPagination(val) {
      const route = `search/contact?page=${val}`;
      const data = { group_id: this.pagination.group_id, value: this.keyword };

      this.sendAsync({ route, data }).then((res) => {
        this.groupContacts = res.data.data;
        this.pagination.current = res.data.current_page;
        this.pagination.total = res.data.last_page;
      });
    },
    createMessage() {
      if (this.tree.length > 0) {
        this.whatsappPreparing = !this.whatsappPreparing;

        this.send({ route: 'whatsapp/selective' }).then((res) => {
          this.prepareData = res.data.data;
          this.$trigger('setInitials');
        });
      }
    },
    whatsappSending(sendData) {
      const data = { ...sendData };
      const ids = this.tree.map(tree => tree.id);
      data.id = JSON.stringify(ids);

      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });

      this.send({
        route: 'whatsapp/selective/send',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'POST',
      }).then(() => {
      }).catch(() => {
      }).finally();
    },
    whatsappPreview(sendData) {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      const data = { ...sendData };
      data.id = this.tree.map(tree => tree.id);

      this.send({ route: 'whatsapp/selective/send/preview', data }).then((res) => {
        this.confirmation.context = res.data.data;
      });
    },
    contactSearch(keyword) {
      this.keyword = keyword;
      this.onSearching = true;
      if (keyword === '') {
        this.contactsPagination(this.pagination.current);
      } else {
        const data = {
          value: keyword,
          group_id: this.currentParameter.id,
        };
        this.sendAsync({ route: 'search/contact', data }).then((res) => {
          this.groupContacts = res.data.data;
          this.pagination.current = res.data.current_page;
          this.pagination.total = res.data.last_page;
        });
      }
    },
    contactsPageFinished(len) {
      if (len === 0) {
        this.pagination.current += 1;
        this.contactsPagination(this.pagination.current);
      }
    },
    onScroll(e) {
      /*
      const y = e.target.scrollTop;
      const max = e.target.scrollHeight - e.target.offsetHeight - 1;

      if (max < y) {
        this.pagination.current = this.pagination.current + 1;
        this.loadGroupContacts(this.currentParameter);
      }
       */
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .tt {
    overflow-y: scroll;
    max-height: 250px;
  }
}

@media screen and (min-width: 600px) {
  .tt {
    overflow-y: scroll;
    max-height: 500px;
  }
}
</style>
